import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueSession from 'vue-session'
import IdleVue from 'idle-vue'
import moment from 'moment'
import { closeSocket } from '@/store/socket.js'

Vue.prototype.moment = moment
Vue.use(VueSession, { persist: true })

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 600000, // 10 minutos
  startAtIdle: false
});

// Cierre de sesión y WS por inactividad
eventsHub.$on('idle', async () => {
  try {
    // Cierra el WebSocket si está conectado
    closeSocket();
  } catch (e) {
    // no-op
  }
  try {
    // Cierra sesión y limpia storage
    await store.dispatch('Auth/logout');
  } catch (e) {
    // no-op
  }
  // Redirige a login
  if (router.currentRoute.name !== 'login') {
    router.replace({ name: 'login' }).catch(() => {});
  }
});

Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')